module.exports = __webpack_public_path__ + "3a25b5d040f03caae10968b794710d5c.svg";